export const enum TariffActionTypes {
    SET_USER_ACTIVE_TARIFF_DATA = 'SET_USER_ACTIVE_TARIFF_DATA',
    SET_USER_HISTORICAL_TARIFF_DATA = 'SET_USER_HISTORICAL_TARIFF_DATA',
}
